import CashBackActionType from './cashBackActionType';

export const createCashBack = (data) => ({
  type: CashBackActionType.CREATE_CASH_BACK,
  payload: { data },
});

export const getCashBack = (id, params) => ({
  type: CashBackActionType.GET_CASH_BACK,
  payload: { id, params },
});

export const saveCashBack = (data) => ({
  type: CashBackActionType.SAVE_CASH_BACK,
  payload: { data },
});

export const resetCashBack = () => ({
  type: CashBackActionType.RESET_CASH_BACK,
});

export const editCashBack = (data) => ({
  type: CashBackActionType.EDIT_CASH_BACK,
  payload: { data },
});
